module.exports = "<select [id]=\"this.element\" [class.is-invalid]=\"error\" [disabled]=\"disabled\" class=\"form-control select2\"></select>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-single/select2-single.component.html
// module id = ./src/app/components/tools/select2/select2-single/select2-single.component.html
// module chunks = main